/* tmk-pdp.js: merch.timothymk.com product pages (2026-10-01). Sticky mobile Add to cart + required Size.
 * 2026-10-02: bar shown only after Size + main Add to cart are both above the viewport (scroll/rAF check).
 * 2026-10-02 v3 (Webmaster review): while no size is chosen, a colour change moves the hidden size to the first size
 *   AVAILABLE in that colour (so Dawn never resolves e.g. Soft Pink / XS = Unavailable); ?variant= deep link = size chosen;
 *   "From $X" before a size is chosen when sizes are priced differently; sticky tap submits the form (requestSubmit)
 *   instead of a synthetic click, so one tap = one click event.
 * 2026-10-02 v4 (QA build 2): ?variant= counts as chosen ONLY if present on first load (captured before Dawn
 *   rewrites the URL); while the size is pending the address bar stays clean (no ?variant=, UTM/other params kept);
 *   main price shows "From $X" before a size is chosen when sizes are priced differently; after Back/Forward or reload the
 *   restored radios are re-synced to the variant the form will add.
 * Works with the Dawn 15 product-info / product-form / variant-selects markup; never changes prices or variants,
 * never adds to cart itself: the sticky button clicks the main Add to cart button, so cart, drawer and analytics
 * behave exactly as a normal add. */
(function () {
  'use strict';
  var bar = document.getElementById('TmkStickyAtc');
  var info = document.querySelector('product-info[id^="MainProduct-"]');
  if (!info) return;
  var section = info.dataset.section;
  var variants = {};
  try { variants = JSON.parse(document.getElementById('TmkPdpVariants').textContent); } catch (e) {}
  var mq = window.matchMedia('(max-width: 749px)');
  var sizeChosen = false;
  // A deep link that names a variant (?variant=<id>, ads / email) counts as an explicit size choice, but ONLY if it was
  // in the URL on this first page load. While the size is pending we keep ?variant= out of the address bar (below), so
  // a reload, Back/Forward or a copied link of a "colour picked, no size" page never looks like a chosen size.
  var initialParams = new URLSearchParams(location.search);
  try { var qv = initialParams.get('variant'); if (qv && variants[qv]) sizeChosen = true; } catch (e) {}
  // Dawn's product-info writes `${url}?variant=<id>` with history.replaceState on every option change (dropping any
  // UTM params). Rewrite only those same-path product URLs: pending size -> no variant; always keep the landing params.
  (function () {
    var orig = history.replaceState;
    if (!orig || history.__tmkPdp) return; history.__tmkPdp = true;
    history.replaceState = function (state, title, url) {
      try {
        if (url != null) {
          var u = new URL(String(url), location.href);
          if (u.origin === location.origin && u.pathname === location.pathname) {
            var vid = u.searchParams.get('variant'), out = new URLSearchParams();
            initialParams.forEach(function (val, key) { if (key !== 'variant') out.append(key, val); });
            u.searchParams.forEach(function (val, key) { if (key !== 'variant' && !out.has(key)) out.append(key, val); });
            if (vid && !sizePendingNow()) out.set('variant', vid);
            var qs = out.toString(); url = u.pathname + (qs ? '?' + qs : '') + u.hash;
          }
        }
      } catch (e) {}
      return orig.call(this, state, title, url);
    };
  })();
  function sizePendingNow() { return !!sizeFieldset() && !sizeChosen; }
  function cleanUrlIfPending() {
    if (!sizePendingNow()) return;
    if (new URLSearchParams(location.search).has('variant')) history.replaceState(history.state, '', location.pathname + location.search + location.hash);
  }

  function mainForm() { return document.getElementById('product-form-' + section); }
  function mainBtn() { return document.getElementById('ProductSubmitButton-' + section); }
  // Label text without our injected "Choose a size" hint (otherwise "SizeChoose a size" fails the match).
  function ownText(el) {
    var t = '';
    el.childNodes.forEach(function (n) { if (!(n.classList && n.classList.contains('tmk-size-hint'))) t += n.textContent; });
    return t;
  }
  function sizeFieldset() {
    var fs = info.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < fs.length; i++) {
      var l = fs[i].querySelector('legend');
      if (l && /^\s*size\b/i.test(ownText(l))) return fs[i];
    }
    var sel = info.querySelectorAll('variant-selects .product-form__input--dropdown');
    for (var j = 0; j < sel.length; j++) { var lb = sel[j].querySelector('label'); if (lb && /^\s*size\b/i.test(ownText(lb))) return sel[j]; }
    return null;
  }
  function sizeRequired() { return !!sizeFieldset() && !sizeChosen; }

  // ---------- money ----------
  function money(cents) {
    var fmt = (bar && bar.dataset.moneyFormat) || '${{amount}}';
    var n = (cents / 100);
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return two;
    });
  }

  // ---------- required size ----------
  // Main button label while no size is chosen: stays enabled and says "Choose a size" (tap -> demandSize via the gate).
  var CHOOSE = 'Choose a size';
  function mainBtnLabel() {
    var mb = mainBtn(); if (!mb) return;
    var span = mb.querySelector('span'); if (!span) return;
    var addTxt = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    var pendingNow = !!sizeFieldset() && !sizeChosen;
    var cur = span.textContent.trim();
    if (pendingNow && !mb.disabled && cur !== CHOOSE && cur === addTxt.trim()) { span.textContent = CHOOSE; mb.dataset.tmkChoose = '1'; }
    else if (!pendingNow && mb.dataset.tmkChoose && cur === CHOOSE) { span.textContent = addTxt; delete mb.dataset.tmkChoose; }
  }
  // Lowest/highest available price across sizes for the currently selected other options (colour etc.).
  function sizeRange() {
    var fsz = sizeFieldset(); if (!fsz) return null;
    var groups = pickerGroups(), si = groups.indexOf(fsz), sel = selection(), min = null, max = null;
    for (var id in variants) {
      var w = variants[id], o = w.options || [], same = w.available && o.length === sel.length;
      for (var k = 0; same && k < sel.length; k++) if (k !== si && o[k] !== sel[k]) same = false;
      if (same) { min = min === null ? w.price : Math.min(min, w.price); max = max === null ? w.price : Math.max(max, w.price); }
    }
    return min === null ? null : { min: min, max: max };
  }
  // Main price: "From $X" while the size is pending on products whose sizes are priced differently (matches the bar).
  function mainPriceFrom() {
    var el = document.querySelector('#price-' + section + ' .price__regular .price-item--regular');
    if (!el) return;
    var r = sizePendingNow() ? sizeRange() : null;
    if (r && r.max !== r.min) {
      var cur = el.textContent.trim(), suffix = (cur.match(/\s([A-Z]{3})$/) || [])[1];
      var want = 'From ' + money(r.min) + (suffix ? ' ' + suffix : '');
      if (cur !== want) { if (!el.dataset.tmkOrig) el.dataset.tmkOrig = cur; el.textContent = want; }
    } else if (el.dataset.tmkOrig && /^From /.test(el.textContent.trim())) { el.textContent = el.dataset.tmkOrig; delete el.dataset.tmkOrig; }
  }
  function applySizeState() {
    mainBtnLabel(); mainPriceFrom(); cleanUrlIfPending();
    var fs = sizeFieldset(); if (!fs) return;
    fs.classList.toggle('tmk-size-pending', !sizeChosen);
    var legend = fs.querySelector('legend');
    var hint = fs.querySelector('.tmk-size-hint');
    if (!sizeChosen && legend && !hint) {
      hint = document.createElement('span'); hint.className = 'tmk-size-hint'; hint.textContent = 'Choose a size';
      legend.appendChild(hint);
    } else if (sizeChosen && hint) hint.remove();
    var err = fs.querySelector('.tmk-size-error');
    if (!err) {
      err = document.createElement('p'); err.className = 'tmk-size-error'; err.id = 'TmkSizeError-' + section;
      err.setAttribute('role', 'alert'); err.hidden = true; fs.appendChild(err);
    }
    if (sizeChosen) err.hidden = true;
    fs.querySelectorAll('input[type=radio]').forEach(function (i) { i.setAttribute('aria-describedby', err.id); });
  }
  function demandSize() {
    var fs = sizeFieldset(); if (!fs) return;
    applySizeState();
    var err = fs.querySelector('.tmk-size-error');
    err.textContent = ''; var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = 'Error: ';
    err.appendChild(sr); err.appendChild(document.createTextNode('Please choose a size.')); err.hidden = false;
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    fs.classList.remove('tmk-size-flash'); void fs.offsetWidth; fs.classList.add('tmk-size-flash');
    var first = fs.querySelector('input[type=radio]:not([disabled]), select');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 350);
  }
  // A tap on any size value (including the one Dawn pre-selected) counts as choosing it.
  info.addEventListener('click', function (e) {
    var fs = sizeFieldset();
    if (fs && e.target.closest && fs.contains(e.target) && (e.target.matches('input[type=radio]') || e.target.closest('label'))) {
      sizeChosen = true; applySizeState(); updateBar();
      setTimeout(function () {                                   // size is now explicit: let the URL carry the variant
        var f = mainForm(), idEl = f && f.querySelector('input[name="id"]');
        if (idEl && idEl.value) { var q = new URLSearchParams(location.search); q.set('variant', idEl.value); history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash); }
      }, 600);
    }
  });
  info.addEventListener('change', function (e) {
    var fs = sizeFieldset();
    if (fs && fs.contains(e.target)) { sizeChosen = true; applySizeState(); }
    setTimeout(updateBar, 0);
  });
  // ---------- colour change while size is still unchosen ----------
  function pickerGroups() { return Array.prototype.slice.call(info.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown')); }
  function groupValue(g) {
    var c = g.querySelector('input:checked'); if (c) return c.value;
    var sel = g.querySelector('select'); return sel ? sel.value : null;
  }
  function selection() { return pickerGroups().map(groupValue); }
  function findVariant(opts, wantAvailable) {
    for (var id in variants) {
      var v = variants[id], o = v.options || [];
      if (o.length !== opts.length) continue;
      var ok = true; for (var i = 0; i < opts.length; i++) if (o[i] !== opts[i]) { ok = false; break; }
      if (ok && (!wantAvailable || v.available)) return v;
    }
    return null;
  }
  // Keep the hidden (unchosen) size on a value that exists + is available for the newly picked colour.
  function realignHiddenSize() {
    var fs = sizeFieldset(); if (!fs) return;
    var groups = pickerGroups(), si = groups.indexOf(fs); if (si < 0) return;
    var sel = selection();
    if (findVariant(sel, true)) return;                         // current combination is fine
    var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]'));
    var pick = null, fallback = null;
    for (var i = 0; i < inputs.length; i++) {
      var opts = sel.slice(); opts[si] = inputs[i].value;
      if (findVariant(opts, true)) { pick = inputs[i]; break; }
      if (!fallback && findVariant(opts, false)) fallback = inputs[i];
    }
    pick = pick || fallback;
    if (pick && !pick.checked) pick.checked = true;            // no change event: does not count as choosing a size
    var dd = fs.querySelector('select');
    if (dd && !pick) {
      for (var j = 0; j < dd.options.length; j++) { var o2 = sel.slice(); o2[si] = dd.options[j].value; if (findVariant(o2, true)) { dd.value = dd.options[j].value; break; } }
    }
  }
  info.addEventListener('change', function (e) {
    if (sizeChosen) return;
    var fs = sizeFieldset();
    if (!fs || fs.contains(e.target) || !e.target.closest || !e.target.closest('variant-selects')) return;
    realignHiddenSize();
  }, true);

  // Gate the main product form only (capture phase on document runs before Dawn's product-form submit handler).
  document.addEventListener('submit', function (e) {
    var f = mainForm();
    if (!f || e.target !== f) return;
    if (sizeRequired()) { e.preventDefault(); e.stopImmediatePropagation(); demandSize(); }
  }, true);
  // Dawn re-renders variant-selects on every option change: re-apply our state afterwards.
  var reapply = null;
  new MutationObserver(function () { clearTimeout(reapply); reapply = setTimeout(function () { applySizeState(); updateBar(); }, 30); })
    .observe(info, { childList: true, subtree: true });

  // Back/Forward + reload: the browser restores the radios the shopper had ticked, but the page (with no ?variant= in
  // the URL while the size was pending) was rendered for the default variant. Put the radios back on the variant the
  // form will actually add, so what is ticked always matches the cart line and the price shown.
  function syncRestoredInputs() {
    var f = mainForm(), idEl = f && f.querySelector('input[name="id"]'), v = idEl && variants[idEl.value];
    if (!v || !v.options) return;
    pickerGroups().forEach(function (g, i) {
      var want = v.options[i]; if (want == null) return;
      var r = g.querySelectorAll('input[type=radio]');
      for (var k = 0; k < r.length; k++) if (r[k].value === want && !r[k].checked) r[k].checked = true;  // no change event
      var sel = g.querySelector('select'); if (sel && sel.value !== want) sel.value = want;
    });
  }
  syncRestoredInputs();
  window.addEventListener('pageshow', function () { syncRestoredInputs(); applySizeState(); if (typeof updateBar === 'function' && bar) updateBar(); });

  // ---------- sticky bar ----------
  if (!bar) { applySizeState(); return; }
  var btn = bar.querySelector('[data-tmk-sticky-btn]'), vlabel = bar.querySelector('[data-tmk-variant]');
  function currentVariant() {
    var f = mainForm(); var id = f && f.querySelector('input[name="id"]') ? f.querySelector('input[name="id"]').value : '';
    return id ? (variants[id] || null) : null;
  }
  function updateBar() {
    var v = currentVariant();
    if (!v) { btn.disabled = true; btn.textContent = bar.dataset.labelUnavailable || 'Unavailable'; if (vlabel) vlabel.textContent = ''; }
    else if (!v.available) {
      btn.disabled = true; btn.textContent = bar.dataset.labelSoldout || 'Sold out'; if (vlabel) vlabel.textContent = v.title;
    } else {
      var priceText = money(v.price);
      if (sizeRequired()) {                                      // sizes priced differently: show the lowest available price
        var fsz = sizeFieldset(), groups = pickerGroups(), si = groups.indexOf(fsz), sel = selection(), min = null, max = null;
        for (var id in variants) {
          var w = variants[id], o = w.options || [], same = w.available && o.length === sel.length;
          for (var k = 0; same && k < sel.length; k++) if (k !== si && o[k] !== sel[k]) same = false;
          if (same) { min = min === null ? w.price : Math.min(min, w.price); max = max === null ? w.price : Math.max(max, w.price); }
        }
        if (min !== null && max !== min) priceText = 'From ' + money(min);
      }
      btn.disabled = false; btn.textContent = (bar.dataset.labelAdd || 'Add to cart') + ' – ' + priceText;
      if (vlabel) {
        var t = v.title;
        if (sizeRequired()) {
          var fs = sizeFieldset(), chk = fs && fs.querySelector('input:checked'), sv = chk ? chk.value : null;
          t = t.split(' / ').filter(function (part) { return part !== sv; }).join(' / ');
          t = (t ? t + ' · ' : '') + 'choose a size';
        }
        vlabel.textContent = t;
      }
      if (vlabel && Object.keys(variants).length === 1) vlabel.textContent = '';
    }
    bar.setAttribute('aria-label', btn.textContent);
  }
  function cookieBannerShowing() {
    var b = document.getElementById('shopify-pc__banner') || document.querySelector('[id^="shopify-pc__banner"], .shopify-pc__banner__dialog');
    if (!b) return false; var r = b.getBoundingClientRect(), cs = getComputedStyle(b);
    return r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden';
  }
  // Show only once BOTH the picker (Size, or the option picker on products without Size) and the main Add to cart
  // button have scrolled ABOVE the viewport, so the bar can never cover the size row or duplicate a visible button.
  function above(el) { return !!el && el.getBoundingClientRect().bottom <= 0; }
  function pickerEl() { return sizeFieldset() || info.querySelector('variant-selects') || mainForm(); }
  function footerShowing() {
    var f = document.querySelector('footer, .footer, [id*="__footer"]');
    return !!f && f.getBoundingClientRect().top < window.innerHeight;
  }
  function setVisible() {
    var drawerOpen = !!document.querySelector('cart-drawer.active, cart-drawer.animate.active, .drawer.active');
    var pk = pickerEl(), mb = mainBtn();
    var on = mq.matches && (!pk || above(pk)) && (!mb || above(mb)) && !footerShowing() && !cookieBannerShowing() && !drawerOpen;
    bar.classList.toggle('is-off', !on);
    if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    if (sizeRequired()) { demandSize(); return; }
    var mb = mainBtn();
    if (!mb || mb.disabled || mb.getAttribute('aria-disabled') === 'true') return;
    var f = mainForm();
    // requestSubmit runs the same submit path as the main button (our size gate + Dawn's product-form handler) without a
    // second synthetic click, so analytics log one click per tap.
    if (f && typeof f.requestSubmit === 'function') f.requestSubmit(mb); else mb.click();
  });
  var ticking = false;
  function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; setVisible(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  // lazy sections (related products) change the page height without a scroll event
  if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(document.body);
  document.addEventListener('click', function () { setTimeout(setVisible, 50); }, true);
  if (mq.addEventListener) mq.addEventListener('change', setVisible); else if (mq.addListener) mq.addListener(setVisible);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(updateBar, 0); });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(setVisible, 400); });
  }
  setInterval(setVisible, 1500);  // cheap safety net for cookie banner / drawer state changes
  applySizeState(); updateBar(); setVisible();
})();
